import type { CityConfig } from "../city-template/types";

export const chesterfieldMOConfig: CityConfig = {
  city: "Chesterfield",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "chesterfield-mo",
  route: "/chesterfield-mo",
  title: "Emergency Passport Chesterfield, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Chesterfield, MO — as fast as 24 hours. Serving West St. Louis County and the greater St. Louis metro. A+ BBB rated registered State Dept. courier serving Chesterfield, Ballwin, and Wildwood. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Chesterfield, MO",
  heroSubtitle: "Corporate trip to London from Lambert with a week to spare? Family vacation to Italy and your passport expired? Chesterfield Valley business meeting in Asia with tight deadlines? We help Chesterfield residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Chesterfield%20Missouri%20upscale%20West%20St.%20Louis%20County%20suburban%20community%20Chesterfield%20Valley%20with%20the%20Missouri%20River%20in%20distance%20modern%20corporate%20buildings%20Chesterfield%20Mall%20area%20tree-lined%20boulevards%20and%20green%20parks%20professional%20drone%20photography%20golden%20hour%20warm%20soft%20light&width=1800&height=700&seq=chesterfield-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Chesterfield Missouri West St. Louis County suburban landscape with Missouri River valley at golden hour",
  geoPosition: "38.6531;-90.5772",
  geoPlacename: "Chesterfield, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 310 miles northeast of Chesterfield via I-55",
  },
  nearbyCitiesZips: [
    { name: "Chesterfield", zips: "63005, 63017" },
    { name: "Ballwin", zips: "63011, 63021" },
    { name: "Wildwood", zips: "63005, 63021, 63038" },
    { name: "Ellisville", zips: "63011, 63021" },
    { name: "Manchester", zips: "63011" },
    { name: "Town and Country", zips: "63017, 63131" },
    { name: "Des Peres", zips: "63131" },
    { name: "Creve Coeur", zips: "63141" },
    { name: "Maryland Heights", zips: "63043" },
    { name: "St. Charles", zips: "63301, 63303" },
    { name: "O'Fallon", zips: "63366, 63368" },
    { name: "St. Louis", zips: "63101–63199" },
    { name: "Kirkwood", zips: "63122" },
    { name: "Webster Groves", zips: "63119" },
    { name: "Ladue", zips: "63124" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent St. Louis metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "West St. Louis County", desc: "Serving Chesterfield, Ballwin, Wildwood, and West County communities" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/st-louis" },
    { name: "Fast passport renewal in St. Charles, MO", route: "/st-charles" },
    { name: "Emergency passport help in O'Fallon, MO", route: "/ofallon-mo" },
    { name: "Urgent passport services in Columbia, MO", route: "/columbia-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Springfield, IL", route: "/springfield-il" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Chesterfield remotely via secure courier. We do not have a walk-in office in Chesterfield — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for West St. Louis County and the St. Louis metro.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of West St. Louis County including Chesterfield, Ballwin, Wildwood, and surrounding communities",
  serviceAreaIntro: "From the corporate headquarters and shopping destinations of Chesterfield Valley to the beautiful parks and trails of Ballwin, from the expansive green spaces and nature preserves of Wildwood to the charming communities of Ellisville and Manchester, from the estates of Town and Country to the business districts of Creve Coeur — Fast Passport Center serves the entire West St. Louis County and greater St. Louis metro area. We regularly help travelers from Chesterfield, Ballwin, and surrounding communities get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Chesterfield neighborhoods and the surrounding West St. Louis County area including Ballwin, Wildwood, Ellisville, Manchester, Town and Country, and Des Peres. If you are anywhere in West St. Louis County or the St. Louis metro, we have you covered.",
  howItWorksIntro: "Most Chesterfield travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Chesterfield travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Chesterfield and West St. Louis County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Chesterfield? Here are the most common ones we hear from West County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Missouri Vital Records (Birth, Death, Marriage)", href: "https://health.mo.gov/data/vitalrecords/" },
    { label: "St. Louis County Vital Records", href: "https://stlouiscountymo.gov/st-louis-county-departments/public-health/vital-records/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Chesterfield travelers with immediate departure needs — as fast as 24 hours for urgent international flights from STL.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Robert K.",
      location: "Chesterfield, MO",
      rating: 5,
      text: "C-suite trip to Tokyo with 4 days notice. Realized my passport expired two months ago. Fast Passport Center got my renewal in 28 hours. I presented to the board on Wednesday. West County's secret weapon for executive travel!",
      service: "Passport Renewal",
    },
    {
      name: "Nancy P.",
      location: "Ballwin, MO",
      rating: 5,
      text: "Mediterranean cruise departing in 6 days and my passport was water-damaged. Fast Passport Center got a replacement in 30 hours. We didn't miss the ship. Truly remarkable service!",
      service: "Damaged Passport",
    },
    {
      name: "Brian T.",
      location: "Wildwood, MO",
      rating: 5,
      text: "Both kids needed first passports for a school exchange program in Germany. We had 10 days. Fast Passport Center got them done in 4 days. The dedicated agent was incredible. West County families — this is the only way!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "chesterfield-mo-1",
      name: "Chesterfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "400 Chesterfield Center",
      city: "Chesterfield",
      state: "MO",
      zip: "63017",
      phone: "(636) 536-4411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chesterfield Center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Chesterfield facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "chesterfield-mo-2",
      name: "St. Louis County Clerk — Clayton",
      type: "County Clerk Passport Acceptance",
      address: "41 S Central Ave, 2nd Floor",
      city: "Clayton",
      state: "MO",
      zip: "63105",
      phone: "(314) 615-7100",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "12 miles east of Chesterfield",
      website: "https://www.stlouiscountymo.gov",
      websiteLabel: "St. Louis County Clerk",
      notes: "Accepts passport applications at the St. Louis County Government Center. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "chesterfield-mo-3",
      name: "Ballwin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15455 Manchester Rd",
      city: "Ballwin",
      state: "MO",
      zip: "63011",
      phone: "(636) 394-1130",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles southeast of Chesterfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ballwin and south Chesterfield area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "chesterfield-mo-4",
      name: "Des Peres Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Des Peres Rd",
      city: "Des Peres",
      state: "MO",
      zip: "63131",
      phone: "(314) 822-6616",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles east of Chesterfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Des Peres and Town and Country. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "chesterfield-mo-5",
      name: "Manchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14317 Manchester Rd",
      city: "Manchester",
      state: "MO",
      zip: "63011",
      phone: "(636) 227-7220",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southeast of Chesterfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Manchester and Ellisville. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Chesterfield photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at St. Louis County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Chesterfield applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many West County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Chesterfield travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Chesterfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Chesterfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Chesterfield before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Chesterfield for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Chesterfield?", a: "Fast Passport Center offers fast passport renewal in Chesterfield in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Chesterfield?", a: "The nearest regional passport agency to Chesterfield is the Chicago Passport Agency, approximately 310 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Chesterfield without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Chesterfield?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Chesterfield — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for West St. Louis County and St. Louis metro residents." },
    { q: "Do you serve the entire West St. Louis County region?", a: "Absolutely. Fast Passport Center serves the entire West St. Louis County and St. Louis metro region including Chesterfield, Ballwin, Wildwood, Ellisville, Manchester, and surrounding areas. Our courier service works seamlessly from any address in West St. Louis County." },
    { q: "Can I expedite a child passport in Chesterfield?", a: "Yes. Fast Passport Center expedites child passports in Chesterfield for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk West County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Chesterfield with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Chesterfield", address: "151 Hilltown Village Center, Chesterfield, MO 63017", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Chesterfield", address: "16800 Chesterfield Airport Rd, Chesterfield, MO 63005", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Ballwin", address: "14750 Manchester Rd, Ballwin, MO 63011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart Supercenter — Manchester", address: "201 Highlands Blvd Dr, Manchester, MO 63011", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Chesterfield",
      address: "1620 Clarkson Rd, Chesterfield, MO 63017",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Convenient West County location. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Maplewood",
      address: "7350 Manchester Rd, Maplewood, MO 63143",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves central St. Louis County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — St. Charles",
      address: "2490 Raymond Dr, St. Charles, MO 63301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves St. Charles County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "18 miles northeast of Chesterfield",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub with direct flights worldwide. About 25 minutes from Chesterfield via I-64/I-170.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "110 miles west of Chesterfield",
      address: "11300 Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to major hubs. About 1 hour 45 minutes from Chesterfield via I-70.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "250 miles west of Chesterfield",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international hub. About 3 hours 50 minutes from Chesterfield via I-70.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
  ],
};